import type { IPeopleFilterProps } from "@organisms/PeopleFilter/interface";
import { IDS } from "@utils/constants";

export const peopleFilterInitialValues: IPeopleFilterProps = {
  search: "",
  role_id: IDS.ROLES.INSPECTOR,
  country_id: "",
  hcm: null,
  global: null,
  bhge: null,
  city: "",
  type_id: "",
  location_id: "",
  inactive: null,
  attributes: [],
  isRadius: false,
  radius: 0,
};
